export const StyledToolTip = {
    'white-space': 'nowrap',
    width: 'auto',
    'text-align': 'left',
};
